import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';
import { CommonCancellationsCrumbs } from './breadcrumb';

export const AnscNotificationsCancellationsCrumbs = [
  ...CommonCancellationsCrumbs,
  {
    name: 'Notifiche da ANSC',
    path: '/cancellazioni/notifiche/ansc',
  },
];

export const DetailAnscNotificationsCancellationsCrumbs = [
  ...AnscNotificationsCancellationsCrumbs,
  {
    name: 'Dettaglio Notifiche da ANSC',
    path: '/cancellazioni/notifiche/ansc/visualizza/:id/:idNotifica',
  },
];

export const EditAnscNotificationsCancellationsCrumbs = (
  goBackUrl = '/cancellazioni/notifiche/ansc/modifica/:id/:idNotifica'
): Array<BreadcrumbItem> => {
  return [
    ...AnscNotificationsCancellationsCrumbs,
    {
      name: 'Modifica Notifiche da ANSC',
      path: goBackUrl,
    },
  ];
};

export const BirthAnscNotificationsNonResidentCancellationsCrumbs = (
  goBackUrl = '/cancellazioni/notifiche/ansc/modifica/:id/:idNotifica'
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Registrazione Nascita Non Residenti',
      path: `${goBackUrl}/nascita/non-residenti`,
    },
  ];
};

export const CivilUnionAnscNotificationsResidentCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/unione-civile/residenti`,
    },
  ];
};

export const CivilUnionDetailAnscNotificationsResidentCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...CivilUnionAnscNotificationsResidentCancellationsCrumbs(goBackUrl),
    {
      name: 'Registrazione Unione Civile',
      path: `${goBackUrl}/unione-civile/residenti/registrazione`,
    },
  ];
};

export const CivilUnionAnscNotificationsNonResidentCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/unione-civile/non-residenti`,
    },
  ];
};

export const CivilUnionDetailAnscNotificationsNonResidentCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...CivilUnionAnscNotificationsNonResidentCancellationsCrumbs(goBackUrl),
    {
      name: 'Registrazione Unione Civile Non Residenti',
      path: `${goBackUrl}/unione-civile/non-residenti/registrazione`,
    },
  ];
};

export const MarriageAnscNotificationsResidentCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/matrimonio/residenti`,
    },
  ];
};

export const MarriageDetailAnscNotificationsResidentCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...MarriageAnscNotificationsResidentCancellationsCrumbs(goBackUrl),
    {
      name: 'Registrazione Matrimonio',
      path: `${goBackUrl}/matrimonio/residenti/registrazione`,
    },
  ];
};

export const MarriageAnscNotificationsNonResidentCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/matrimonio/non-residenti`,
    },
  ];
};

export const MarriageDetailAnscNotificationsNonResidentCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...MarriageAnscNotificationsNonResidentCancellationsCrumbs(goBackUrl),
    {
      name: 'Registrazione Matrimonio Non Residenti',
      path: `${goBackUrl}/matrimonio/non-residenti/registrazione`,
    },
  ];
};

export const DeathAnscNotificationsResidentCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/morte/residenti`,
    },
  ];
};

export const DeathCancellationAnscNotificationsResidentCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...DeathAnscNotificationsResidentCancellationsCrumbs(goBackUrl),
    {
      name: 'Cancellazione',
      path: `${goBackUrl}/morte/residenti/cancellazione`,
    },
  ];
};

export const DeathAnscNotificationsNonResidentCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/morte/non-residenti`,
    },
  ];
};

export const DeathCancellationAnscNotificationsNonResidentCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...DeathAnscNotificationsNonResidentCancellationsCrumbs(goBackUrl),
    {
      name: 'Cancellazione',
      path: `${goBackUrl}/morte/non-residenti/cancellazione`,
    },
  ];
};

export const CitizenshipAnscNotificationsCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/cittadinanza/ricerca`,
    },
  ];
};

export const CitizenshipRegistrationAnscNotificationsCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...CitizenshipAnscNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Registrazione',
      path: `${goBackUrl}/cittadinanza/ricerca/registrazione`,
    },
  ];
};

export const FamilyAnscNotificationsCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia`,
    },
  ];
};

export const FamilyOtherAnscNotificationsCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia/altra`,
    },
  ];
};

export const FamilyMotherAnscNotificationsCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia/madre`,
    },
  ];
};

export const FamilyFatherAnscNotificationsCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia/padre`,
    },
  ];
};

export const FamilyDetailAnscNotificationsCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...FamilyAnscNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/cancellazioni/notifiche/ansc/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyOtherDetailAnscNotificationsCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...FamilyOtherAnscNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/cancellazioni/notifiche/ansc/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyMotherDetailAnscNotificationsCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...FamilyMotherAnscNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/cancellazioni/notifiche/ansc/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyFatherDetailAnscNotificationsCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...FamilyFatherAnscNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/cancellazioni/notifiche/ansc/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const CohabitationAnscNotificationsCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Convivenza',
      path: `${goBackUrl}/convivenza`,
    },
  ];
};

export const CohabitationDetailAnscNotificationsCancellationsCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...CohabitationAnscNotificationsCancellationsCrumbs(goBackUrl),
    {
      name: 'Nascita Convivenza',
      path: '/cancellazioni/notifiche/ansc/modifica/:id/:idNotifica/convivenza/nascita',
    },
  ];
};
